/* =====================================================================
   ZZ Countdown Bar — Announcement-Bar mit Live-Countdown.
   Liest data-end (ISO-Datum) und tickt sekündlich.
   Ablauf-Verhalten via data-expired: 'hide' (Bar ausblenden) oder
   'zeros' (00 stehen lassen). Im Theme-Editor wird nie versteckt.
   Idempotent; re-init bei shopify:section:load.
   ===================================================================== */
(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function init(root) {
    if (!root || root.__zzCdbInit) return;
    root.__zzCdbInit = true;

    var end = new Date(root.getAttribute('data-end'));
    var expiredBehavior = root.getAttribute('data-expired') || 'hide';
    var isEditor = typeof Shopify !== 'undefined' && Shopify.designMode;

    var elD = root.querySelector('[data-zz-cdb-d]');
    var elH = root.querySelector('[data-zz-cdb-h]');
    var elM = root.querySelector('[data-zz-cdb-m]');
    var elS = root.querySelector('[data-zz-cdb-s]');
    if (!elD || !elH || !elM || !elS) return;

    // Ungültiges Datum → Nullen anzeigen, nichts verstecken (Editor-Hilfe)
    if (Number.isNaN(end.getTime())) {
      elD.textContent = elH.textContent = elM.textContent = elS.textContent = '00';
      return;
    }

    var timer;

    function tick() {
      var diff = end.getTime() - Date.now();

      if (diff <= 0) {
        elD.textContent = elH.textContent = elM.textContent = elS.textContent = '00';
        clearInterval(timer);
        if (expiredBehavior === 'hide' && !isEditor) {
          root.hidden = true;
        }
        return;
      }

      var secs = Math.floor(diff / 1000);
      var d = Math.floor(secs / 86400);
      var h = Math.floor((secs % 86400) / 3600);
      var m = Math.floor((secs % 3600) / 60);
      var s = secs % 60;

      elD.textContent = pad(d);
      elH.textContent = pad(h);
      elM.textContent = pad(m);
      elS.textContent = pad(s);
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function boot() {
    document.querySelectorAll('[data-zz-cdb]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-zz-cdb]') : null;
    if (el) init(el);
  });
})();
